/* hs-eslint ignored failing-rules */
/* eslint-disable promise/catch-or-return */

import DisabledInteractionsConfigApi from '../api/DisabledInteractionsConfig';
import * as ActionTypes from './ActionTypes';
function disabledInteractionsConfigReceived(payload) {
  return {
    type: ActionTypes.FETCH_DISABLED_INTERACTIONS_CONFIG_SUCCESS,
    payload
  };
}
function disabledInteractionsConfigRequesting() {
  return {
    type: ActionTypes.FETCH_DISABLED_INTERACTIONS_CONFIG_PENDING
  };
}
function disabledInteractionsConfigRequestFailed(error) {
  return {
    type: ActionTypes.FETCH_DISABLED_INTERACTIONS_CONFIG_ERROR,
    error
  };
}
export function getDisabledInteractionsConfig() {
  return dispatch => {
    dispatch(disabledInteractionsConfigRequesting());
    DisabledInteractionsConfigApi.getDisabledInteractionsConfig().then(response => dispatch(disabledInteractionsConfigReceived(response)), error => dispatch(disabledInteractionsConfigRequestFailed(error)));
  };
}